
import React, { useState } from "react";
import { Span } from "@/components/ui/typography";

interface PulseSearchWordProps {
  className?: string;
  onClick?: () => void;
}

export const PulseSearchWord: React.FC<PulseSearchWordProps> = ({
  className,
  onClick
}) => {
  // Add hover state
  const [isHovered, setIsHovered] = useState(false);
  
  // The word "search" split into individual letters
  const letters = ["s", "e", "a", "r", "c", "h"];
  
  return (
    <button 
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`inline-flex items-baseline cursor-pointer focus:outline-none bg-transparent border-0 p-0 transition-opacity focus:ring-2 focus:ring-mono-slateGray/30 rounded text-mono-platinum/80 ${className || ""}`}
      type="button"
      aria-label="Focus search input"
    >
      {letters.map((letter, index) => (
        <Span 
          key={`${letter}-${index}`} 
          className={`${isHovered ? 'search-hovered' : 'animate-pulse-search'}`}
          style={{
            // Apply animation delay only when not hovered
            animationDelay: !isHovered ? `${index * 0.1}s` : undefined,
            // Ensure smooth transition between states
            transition: "color 0.3s ease-out",
          }}
        >
          {letter}
        </Span>
      ))}
    </button>
  );
};
